import {
  CreateDTO,
  useCreateMutationFactory,
  UseCreateMutationProps,
} from '@/lib/react-query/create';
import { ModelID, PaymentMethod } from '@/types';
import { create } from '@/utils/api';
import { featureKeys, featurePath, PaymentMethodSearchParams } from '.';

type PaymentMethodCreateBase = Omit<Partial<PaymentMethod>, 'payment_method_id' | 'stripe_card_id'>;

type LegacyPaymentMethodToken = PaymentMethodCreateBase & {
  token: string;
};

type StripeSetupIntentReference = PaymentMethodCreateBase & {
  setup_intent_id: string;
  franchise_id: ModelID;
};

type CreatePaymentMethodPayload = LegacyPaymentMethodToken | StripeSetupIntentReference;

export type CreatePaymentMethodDTO = CreateDTO<
  CreatePaymentMethodPayload,
  PaymentMethodSearchParams
>;

const createPaymentMethod = ({ data, params = {} }: CreatePaymentMethodDTO) =>
  create<PaymentMethod>(`${featurePath}`, data, params);

export const useCreatePaymentMethod = (options?: UseCreateMutationProps<PaymentMethod>) => {
  return useCreateMutationFactory({
    invalidateKeys: featureKeys,
    mutationFn: createPaymentMethod,
    ...options,
  });
};
